import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { AudioLines, Cpu, LayoutGrid, Workflow } from "lucide-react";
import { cn } from "@/lib/utils";

const ADMIN_SECTIONS = [
  {
    href: "/settings/admin",
    label: "Agent Logs",
    description: "All-user sessions, costs, and runtime controls.",
    icon: LayoutGrid,
  },
  {
    href: "/console",
    label: "Agent console",
    description: "Agents, playground, and runtime sessions (staff-only).",
    icon: Cpu,
  },
  {
    href: "/settings/admin/pipeline-inspector",
    label: "Pipeline Inspector",
    description: "Inspect tree nodes and run prompt audits.",
    icon: Workflow,
  },
  {
    href: "/settings/admin/tts-voices",
    label: "Voice Lab",
    description: "Audition voices and map persona defaults.",
    icon: AudioLines,
  },
];

export default function AdminSettingsNav() {
  const { pathname } = useLocation();

  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {ADMIN_SECTIONS.map((section) => {
        const active =
          section.href === "/settings/admin"
            ? pathname === section.href
            : pathname === section.href || pathname.startsWith(section.href + "/");
        return (
          <Link
            key={section.href}
            to={section.href}
            className={cn(
              "rounded-xl p-3 transition-colors",
              active ? "bg-primary/10 shadow-ambient" : "bg-muted/40 hover:bg-muted/60",
            )}
          >
            <div className="mb-2 flex items-center justify-between gap-2">
              <div className="inline-flex items-center gap-2">
                <section.icon
                  className={cn("h-4 w-4", active ? "text-foreground" : "text-muted-foreground")}
                />
                <p
                  className={cn(
                    "ds-body-sm-strong",
                    active ? "text-foreground" : "text-foreground",
                  )}
                >
                  {section.label}
                </p>
              </div>
              {active ? (
                <span className="ds-micro-strong rounded-md bg-foreground px-1.5 py-0.5 uppercase text-background">
                  Current
                </span>
              ) : null}
            </div>
            <p className="ds-caption text-muted-foreground">{section.description}</p>
          </Link>
        );
      })}

    </div>
  );
}
